export default __webpack_public_path__ + "static/media/gene-bcre.1e6ddfd8.png";